import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import { getDisasters } from "../../../../api";
import { formatDate } from "../../../../utils/deteUtils";
import type { DisasterItem, DisasterSelectValue, DisastersListOkResponse } from "../../../../types/mail";

type DisasterSelectProps = {
  changedValue: (value: DisasterSelectValue) => void;
  value?: number | null;
};

const DisasterSelect = ({ changedValue, value }: DisasterSelectProps) => {
  const [disasters, setDisasters] = useState<DisasterItem[]>([]);
  const [selectedDisaster, setSelectedDisaster] = useState<DisasterItem | null>(
    null
  );

  const fetchDisasters = async () => {
    try {
      const response = (await getDisasters({
        name: null,
        is_completed: true,
        exclude_id: null,
        start_at_stt: null,
        start_at_end: null,
        order: null,
        sort: null,
        page: 1,
        limit: null,
      })) as DisastersListOkResponse;
      if (response.status !== "ok") {
        return;
      }
      const data = response.disasters;
      if (data) {
        setDisasters(data);

        const initialDisaster = data.find((disaster) => disaster.id === value);
        setSelectedDisaster(initialDisaster ?? null);
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    fetchDisasters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (value && disasters.length > 0) {
      const initialDisaster = disasters.find(
        (disaster) => disaster.id === value
      );
      setSelectedDisaster(initialDisaster ?? null);
    }
  }, [value, disasters]);

  const getDisasterLabel = (disaster: DisasterItem): string => {
    const kindLabel =
      disaster.kind === "quake"
        ? " 地震"
        : disaster.kind === "w-r-s"
          ? " 雨風雪"
          : disaster.kind === "manual"
            ? " 手動"
            : " その他";
    return formatDate(disaster.create_at) + kindLabel + disaster.name;
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={disasters}
      value={selectedDisaster}
      getOptionLabel={getDisasterLabel}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderInput={(params) => (
        <TextField {...params} name="disasterSelect" label="災害選択" />
      )}
      onChange={(_event, newValues) => {
        setSelectedDisaster(newValues);
        changedValue({ id: newValues?.id, name: newValues?.name });
      }}
    />
  );
};

export default DisasterSelect;
